import React from "react";
import styles from "../../styles/image.module.scss";

export const Image = ({ img, desc, props }) => {
  return (
    <img src={`${img}.png`} alt={desc} className={styles.image} {...props} />
  );
};
